// extracted by mini-css-extract-plugin
export default {"balance_button":"BalanceButton_balance_button__I189r","align":"BalanceButton_align__s9e6s"};